import { getLabelWithEllipsis } from '@core/Utils/Strings/GetLabelWithEllipsis';
import { Typography } from '@gds/Typography/Typography';
import { PrefetchLink } from '@shared-components/PrefetchLink/PrefetchLink';

import styles from './LinkBlock.module.css';

export type LinkBlockProps = {
  heading: string;
  className?: string;
  ctas: { ctaText: string; link: string }[];
  dataTestId?: string;
  hasLargerCtaTexts?: boolean;
};

export const LinkBlock = (interlinking: LinkBlockProps) => {
  return (
    <div
      className={`${styles.wrpr} ${interlinking.className || ''}`}
      data-test-id={interlinking.dataTestId}
    >
      <div className={styles.ttl}>
        <Typography variant="h3">{interlinking.heading}</Typography>
      </div>
      <div className={styles.layout}>
        <div className={styles.list} data-three-columns={interlinking.hasLargerCtaTexts}>
          {interlinking.ctas.map(cta => {
            return (
              <PrefetchLink
                href={cta.link ?? '/'}
                key={cta.ctaText}
                className={styles.links}
                onClick={cta.onClickFunc}
              >
                {getLabelWithEllipsis(cta.ctaText, 30, 27)}
              </PrefetchLink>
            );
          })}
        </div>
      </div>
    </div>
  );
};

LinkBlock.displayName = 'LinkBlock';
